export const siteSettings = {
  siteName: "Liquid Markets",
  siteLink: "https://liquidmarkets.live",
  siteCropLink: "liquidmarkets.live",
  appLink: "https://app.liquidmarkets.live",
  supportEmail: "support@liquidmarkets.live",
};
